import React from 'react';
export function BrandPartnershipsSlide() {
  const brandLogos = [{
    name: 'Radisson',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Radisson_Hotel_logo.svg'
  }, {
    name: 'W Hotels',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1c/W_Hotels_logo.svg'
  }, {
    name: 'Hyatt Place',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/Hyatt_Place_logo.svg'
  }, {
    name: 'Radisson Blu',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Radisson_Hotel_logo.svg'
  }, {
    name: 'Blue Aruba',
    logo: 'https://images.squarespace-cdn.com/content/v1/5b8e3e7a5417fc0e594f9455/1574447988346-8YVWVYVPVZP1GUTL3Q7E/blue+residences+aruba.png'
  }, {
    name: 'Vacation Aruba',
    logo: 'https://vacationaruba.com/wp-content/uploads/2023/09/Vacation-Aruba-logo.png'
  }, {
    name: 'Embassy Suites',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/1/18/Embassy_Suites_by_Hilton_logo.svg'
  }, {
    name: 'Holiday Inn',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Holiday_Inn_Logo.svg'
  }];
  return <div className="w-full bg-white" data-id="element-552">
      <div className="max-w-5xl mx-auto" data-id="element-553">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-554">
          <div className="md:col-span-1" data-id="element-555">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-556">
              <div className="w-48 h-48 rounded-full overflow-hidden mx-auto mb-6" data-id="element-557">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t9AcqBTZc97z7oLWTJi33G/unnamed_%284%29.png" alt="Fran" className="w-full h-full object-cover" data-id="element-558" />
              </div>
              <h3 className="text-xl font-normal text-black mb-4" data-id="element-559">Contacto</h3>
              <ul className="space-y-3" data-id="element-560">
                <li className="flex items-start" data-id="element-561">
                  <span className="mr-2 text-black" data-id="element-562">—</span>
                  <span className="text-base text-gray-700" data-id="element-563">
                    +52 123 456 789
                  </span>
                </li>
                <li className="flex items-start" data-id="element-564">
                  <span className="mr-2 text-black" data-id="element-565">—</span>
                  <span className="text-base text-gray-700" data-id="element-566">
                    Cancún, México
                  </span>
                </li>
                <li className="flex items-start" data-id="element-567">
                  <span className="mr-2 text-black" data-id="element-568">—</span>
                  <span className="text-base text-gray-700" data-id="element-569">
                    contacto@explorandoconfran.com
                  </span>
                </li>
                <li className="flex items-start" data-id="element-570">
                  <span className="mr-2 text-black" data-id="element-571">—</span>
                  <span className="text-base text-gray-700" data-id="element-572">
                    www.explorandoconfran.com
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:col-span-2" data-id="element-573">
            <h2 className="text-3xl font-normal text-black mb-6" data-id="element-574">
              Marcas con las que he colaborado
            </h2>
            <div className="bg-white p-8 rounded-lg border border-gray-200" data-id="element-575">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-576">
                {brandLogos.map((brand, index) => <div key={index} className="flex items-center justify-center h-16" data-id="element-577">
                    <img src={brand.logo} alt={brand.name} className="max-h-full max-w-full object-contain" data-id="element-578" />
                  </div>)}
              </div>
            </div>
            <div className="mt-8" data-id="element-579">
              <h3 className="text-2xl font-normal text-black mb-4" data-id="element-580">
                Fran Explorador
              </h3>
              <p className="text-base text-gray-700 mb-6 leading-relaxed" data-id="element-581">
                Creador de contenido inmersivo especializado en viajes y
                aventuras
              </p>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-582">
                Apasionado productor de contenido con un ojo detallista y
                motivado por contar historias cautivadoras a través de medios
                visualmente atractivos. Me especializo en crear experiencias
                inmersivas, utilizando tecnología de vanguardia para transportar
                a los espectadores a nuevas alturas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}